/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {

    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetGRNSummaryApprovalDataForReinitiatePayment,
    ApproveFarmer,
    CheckFarmerDocumentAvailability,
    SaveFarmerRejectHistory,
    UpdateGRNSummaryApprovalStatus,
    RejectGRNSummaryApprovalStatus
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet(
        '/api/Factory/GetAllFactoriesByGroupID',
        'groupID=' + parseInt(groupID)
    );
    return response.data;
}

async function ApproveFarmer(farmerID, farmerStatus, farmerCode, givenName, collectionCenterID, navisionNumber) {
    let model = {
        farmerID: parseInt(farmerID),
        farmerStatus: parseInt(farmerStatus),
        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
        farmerCode: farmerCode,
        givenName: givenName,
        collectionCenterID: parseInt(collectionCenterID),
        navisionNumber: navisionNumber
    }
    const response = await CommonPost('/api/Farmer/SaveFarmerApprovalHistory', null, model);
    return response;
}

async function CheckFarmerDocumentAvailability(farmerID) {
    const response = await CommonGet('/api/Farmer/CheckFarmerDocumentAvailability', 'farmerID=' + parseInt(farmerID));
    return response.data;
}

async function SaveFarmerRejectHistory(model) {
    const response = await CommonPost('/api/Farmer/SaveFarmerRejectHistory', null, model);
    return response;
}

async function GetGRNSummaryApprovalDataForReinitiatePayment(values) {
    let model = {
        groupID: parseInt(values.groupID),
        operationEntityID: parseInt(values.operationEntityID),
        statusID: parseInt(values.isActive),
        date: values.date,
    }
    const response = await CommonPost('/api/GRNSummaryApproval/ReinitiatePayment', null, model);
    return response;
}

async function UpdateGRNSummaryApprovalStatus(selectedData) {
    let model = {
        InvoiceNumber: selectedData.farmerID,
        StatusID: parseInt(selectedData.farmerStatus),
        IsReinitiate : selectedData.isReinitiate,
        TransactionType: "",
        FarmerCode: "",
        ModifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    let modelArray = []
    selectedData.forEach(data => {
        model = {
            InvoiceNumber: data.invoiceNumber,
            StatusID: parseInt(data.statusID),
            IsReinitiate : data.isReinitiate,
            TransactionType: data.transactionType,
            FarmerCode: data.farmerCode,
            ModifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
        }
        modelArray.push(model);
    });
    const response = await CommonPost('/api/GRNSummaryApproval/UpdateGRNSummaryApprovalStatus', null, modelArray);
    return response;
}

async function RejectGRNSummaryApprovalStatus(modelArray) {
    const response = await CommonPost('/api/GRNSummaryApproval/RejectGRNSummaryApprovalStatus', null, modelArray);
    return response;
} 